import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record'
import { TopicService } from '../topic.service'
import { RuntimeService } from '../runtime.service'
import { Project } from '../project'
import { Topic } from '../topic'

@Component({
  selector: 'app-topic-selector',
  templateUrl: './topic-selector.component.html',
  styleUrls: ['./topic-selector.component.css']
})
export class TopicSelectorComponent implements OnInit {
  @Input() dbRecord: DbRecord
  project: Project
  assignTopicsOn = false

  constructor(
    private ts: TopicService,
    private rs: RuntimeService
  ) { }

  ngOnInit() {
    this.project = this.rs.currentProject
  }

  switchAssignTopic() {
    this.assignTopicsOn = !this.assignTopicsOn
  }

  get assignedTopics() {
    return this.project.getDbRecordTopics(this.dbRecord)
  }

  selectTopic(t: Topic) {
    this.project.setDbRecordTopic(this.dbRecord, t)
  }

  get topicsList() {
    let s = this.project.getDbRecordTopicsIdSet(this.dbRecord)
    return this.project.topicsList.filter(x => !s.has(x.id))
  }
}



// WEBPACK FOOTER //
// ./src/app/topic-selector/topic-selector.component.ts